import { Dropdown } from "../../../misc/Dropdown";
import { Repeat } from "../../../api/Tasks";
import { nthOptions, weekdayNames } from "../repeatText";

const weekdayOptions = weekdayNames.map((name, day) => ({ value: day, label: name }));

export function NthDayOfWeekPicker(props: {
    repeat: Repeat;
    disabled: boolean;
    allowLast?: boolean;
    onChange: (changes: Partial<Repeat>) => void;
}) {
    const options = props.allowLast === false ? nthOptions.filter(o => o.value > 0) : nthOptions;

    return (
        <span style={{ display: "flex", alignItems: "center", gap: 6 }}>
            On the
            <Dropdown width={70} disabled={props.disabled}
                      value={props.repeat.nth} options={options}
                      onChange={value => props.onChange({ nth: value })} />
            <Dropdown width={110} disabled={props.disabled}
                      value={props.repeat.weekday} options={weekdayOptions}
                      onChange={value => props.onChange({ weekday: value })} />
        </span>
    );
}
